/* unplugin-vue-components disabled */import script from "./Index.vue?vue&type=script&setup=true&lang=ts"
export * from "./Index.vue?vue&type=script&setup=true&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=4d6ad75e&lang=less"

const __exports__ = script;

export default __exports__